import { MeInfo } from "@/graph/servicecloud/me/types/Get";
import Vue from "vue";
import Vuex from "vuex";
import { v4 as uuidv4 } from 'uuid';

Vue.use(Vuex);

export type AuthState = "signedout" | "signedin";

export type UserState = {
	loaded: boolean
	authState: AuthState
	user: null | {
		attributes: UserAttributes
		userDataKey: string
		username: string
		keyPrefix: string
	}
	me: null | MeInfo
	meUpdated: string
};

type UserAttributes = {
	"custom:key": string,
	sub: string,
	email: string,
};

/**
 * Main Store
 */
export default new Vuex.Store({
	state: (): UserState => ({
		loaded: false,
		authState: "signedout",
		user: null,
		me: null,
		meUpdated: "No",
	}),
	mutations: {
		setLoaded(state) {
			state.loaded = true;
		},
		setLoading(state) {
			state.loaded = false;
		},
		setAuthState(state) {
			console.log("setAuthState");
		},
		updateMe(state, me: MeInfo) {
			console.log("STATE:Mutation:updateMe");
			me[uuidv4()] = uuidv4();
			state.me = me;
			state.meUpdated = uuidv4();
		}
	},
	actions: {},
	modules: {},
});
